import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import NotificationsSettingsPage from "components/pages/NotificationsSettingsPage";
import Classes, { ContactInfo } from "model";

export default function CaptureNotifiLimEmailInList(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, controller);

    ContactInfo.create({
        id: 100,
        isPrimary: "false",
        isConfirmed: "true",
        value: "sample@samplemail.com",
        userEnteredActivationCode: "123456",
        type: "email"
    }).submit(Classes);

    return <NotificationsSettingsPage />
}